import {
  AdressesLabel,
  IAddressDetail,
  IAddresses,
  IAddressesRespone,
} from '../types/Adresses';

export const getAddresses = (item?: IAddresses) => {
  return {
    _id: item?._id ?? '',
    title: item?.title ?? '',
    location: {
      lon: item?.location?.lon ?? 0,
      lat: item?.location?.lat ?? 0,
    },
    details: {
      entrance: item?.details?.entrance ?? '',
      intercom: item?.details?.intercom ?? '',
      floor: item?.details?.floor ?? '',
      apartment: item?.details?.apartment ?? '',
      comment: item?.details?.comment ?? '',
    },
    label_type: item?.label_type ?? undefined,
    label_value: item?.label_value ?? undefined,
  };
};

export const getResponseAddresses = (item: IAddressesRespone): IAddresses => {
  let parsedDetails: IAddressDetail = {};

  try {
    parsedDetails = JSON.parse(item.detail || '{}');
  } catch (error) {
    console.error(
      'Failed to parse details JSON:',
      JSON.stringify(error, Object.getOwnPropertyNames(error), 2)
    );
  }

  let labelType: AdressesLabel;
  let labelValue: string | undefined;

  const typeLower = item.type?.toLowerCase() ?? '';

  if (['дом', 'home', 'uy'].includes(typeLower)) {
    labelType = AdressesLabel.HOME;
  } else if (['работа', 'work', 'ish', 'ishxona'].includes(typeLower)) {
    labelType = AdressesLabel.WORK;
  } else {
    labelType = AdressesLabel.OTHERS;
    labelValue = item.type || '';
  }

  // Safely parse geo coordinates with Tashkent center as fallback
  const geoCoords = item.geo?.split(',') || [];
  const TASHKENT_CENTER = { lon: 69.2401, lat: 41.2995 };

  return {
    _id: item.id ?? '',
    title: item.title ?? '',
    location: {
      lon: Number(geoCoords[1]) || TASHKENT_CENTER.lon,
      lat: Number(geoCoords[0]) || TASHKENT_CENTER.lat,
    },
    details: {
      entrance: parsedDetails.dom || '',
      intercom: parsedDetails.kod || '',
      floor: parsedDetails.dop_nomer || '',
      apartment: parsedDetails.kv || '',
      comment: parsedDetails.comment || '',
    },
    label_type: labelType,
    label_value: labelValue,
  };
};
export const addressesAdapter = (data?: IAddressesRespone[]): IAddresses[] =>
  data?.map(item => getResponseAddresses(item)) ?? [];
